import * as types from "./mutation_types";
const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
import axios from "@/lib/axioxAppli";

export const getItems = ({ commit }) => {
  commit(types.TYPE_RELANCE_TOGGLE_LOADING);

  axios
    .get(URL_BACKEND + "api-relance/typeRelance/")
    .then((response) => {
      commit(types.TYPE_RELANCE_TOGGLE_LOADING);
      commit(types.TYPE_RELANCE_SET_ITEMS, response.data);
    })
    .catch((e) => {
      commit(types.TYPE_RELANCE_SET_ITEMS, []);
      commit(types.TYPE_RELANCE_TOGGLE_LOADING);
      commit(types.TYPE_RELANCE_SET_ERROR, e.message);
    });
};
